import { Box, Typography } from '@mui/material';
import React, { FC, Fragment } from 'react';
import {
  BrandKey,
  GetArticleQuery_query_article_Article_events_ArticleEvent,
  GetArticleQuery_query_article_Article_events_ArticleEvent_category_Category,
  GetArticleQuery_query_article_Article_guides_ArticleGuide,
  GetArticleQuery_query_article_Article_tags_ArticleTag,
  GetArticleQuery_query_article_Article_tags_ArticleTag_tag_Tag,
  GetCardQuery_query_card_Card_tags_CardTag,
  GetCardQuery_query_card_Card_tags_CardTag_tag_Tag,
  ArticleLikeInput,
} from '../../__generated__/queries-web';
import { TAGS_SECTION_ID_SELECTOR } from './constants';
import { useStyles } from './styles';

export interface TagsProps {
  article?: ArticleLikeInput;
  brandKey: BrandKey;
  configuration: {
    component: FC<any>;
    id: string;
    props: {
      field: string;
      tags: (
        | GetArticleQuery_query_article_Article_events_ArticleEvent_category_Category
        | GetArticleQuery_query_article_Article_tags_ArticleTag_tag_Tag
        | GetCardQuery_query_card_Card_tags_CardTag_tag_Tag
        | GetArticleQuery_query_article_Article_guides_ArticleGuide
      )[];
      [key: string]: unknown;
    };
  }[];
  onTagsChange: {
    (
      tags: (
        | GetArticleQuery_query_article_Article_events_ArticleEvent
        | GetArticleQuery_query_article_Article_tags_ArticleTag
        | GetCardQuery_query_card_Card_tags_CardTag
        | GetArticleQuery_query_article_Article_guides_ArticleGuide
      )[],
      field?: string,
    ): void;
  };
  title?: string;
  QualifierComponent?: React.ReactNode;
}

export const Tags: FC<TagsProps> = ({
  configuration,
  title,
  QualifierComponent = null,
  ...tagsProps
}) => {
  const classes = useStyles({ withMargin: !!configuration.length });

  if (!configuration.length) {
    return <Fragment />;
  }

  return (
    <Box
      className={classes.wrapper}
      component="section"
      id={TAGS_SECTION_ID_SELECTOR}
    >
      {title && (
        <Typography className={classes.mainTitle} component="h2">
          {title}
        </Typography>
      )}

      {configuration.map(
        ({ component: Tag, id, props: configurationProps }) => (
          <Tag
            key={id}
            suggestedTagList={[]}
            {...tagsProps}
            {...configurationProps}
          />
        ),
      )}
      <br />
      {QualifierComponent}
    </Box>
  );
};
